
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import PendoIconOption from './pendo-icon-option.js';

var timeranges = ['12:00am', '12:15am', '12:30am', '12:45am', '1:00am', '1:15am', '1:30am', '1:45am', '2:00am', '2:15am', '2:30am', '2:45am', '3:00am', '3:15am', '3:30am', '3:45am', '4:00am', '4:15am', '4:30am', '4:45am', '5:00am', '5:15am', '5:30am', '5:45am', '6:00am', '6:15am', '6:30am', '6:45am', '7:00am', '7:15am', '7:30am', '7:45am', '8:00am', '8:15am', '8:30am', '8:45am', '9:00am', '9:15am', '9:30am', '9:45am', '10:00am', '10:15am', '10:30am', '10:45am', '11:00am', '11:15am', '11:30am', '11:45am', '12:00pm', '12:15pm', '12:30pm', '12:45pm', '1:00pm', '1:15pm', '1:30pm', '1:45pm', '2:00pm', '2:15pm', '2:30pm', '2:45pm', '3:00pm', '3:15pm', '3:30pm', '3:45pm', '4:00pm', '4:15pm', '4:30pm', '4:45pm', '5:00pm', '5:15pm', '5:30pm', '5:45pm', '6:00pm', '6:15pm', '6:30pm', '6:45pm', '7:00pm', '7:15pm', '7:30pm', '7:45pm', '8:00pm', '8:15pm', '8:30pm', '8:45pm', '9:00pm', '9:15pm', '9:30pm', '9:45pm', '10:00pm', '10:15pm', '10:30pm', '10:45pm', '11:00pm', '11:15pm', '11:30pm', '11:45pm'];

var script = {
  name: 'PendoTimePicker',
  components: {
    PendoMultiselect,
    PendoIconOption,
    PendoIcon,
    PendoButton
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Select Time'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    options() {
      return timeranges.map(time => ({
        label: time,
        value: time,
        icon: {
          type: 'clock'
        }
      }));
    },

    model: {
      get() {
        return this.options.find(option => option.value === this.value);
      },

      set({
        value
      }) {
        this.$emit('change', value);
        this.$emit('input', value);
      }

    }
  },
  methods: {
    clearModel() {
      this.model = {
        value: null
      };
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-time-picker"
  }, [_c('pendo-multiselect', {
    attrs: {
      "value-key": "value",
      "allow-empty": false,
      "invalid": _vm.invalid,
      "placeholder": _vm.placeholder,
      "labels": _vm.labels,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "selectedLabel",
      fn: function (ref) {
        var option = ref.option;
        return _c('pendo-icon-option', {
          attrs: {
            "option": option
          }
        });
      }
    }, {
      key: "suffix",
      fn: function (ref) {
        var open = ref.open;
        var hover = ref.hover;
        return _c('div', {
          staticClass: "pendo-multiselect__suffix"
        }, [_vm.model && (open || hover) ? _c('pendo-button', {
          staticClass: "pendo-time-picker__clear",
          attrs: {
            "slot": "suffix",
            "type": "tertiary",
            "icon": "x-circle",
            "icon-size": "14",
            "size": "mini"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.clearModel($event);
            }
          },
          slot: "suffix"
        }) : _vm._e()], 1);
      }
    }]),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, [_c('div', {
    staticClass: "pendo-multiselect-option--icon",
    attrs: {
      "slot": "placeholder"
    },
    slot: "placeholder"
  }, [_c('pendo-icon', {
    attrs: {
      "type": "clock",
      "size": "14"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pendo-multiselect-option__label"
  }, [_vm._v("\n                " + _vm._s(_vm.placeholder) + "\n            ")])], 1)])], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-time-picker.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoTimePicker = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoTimePicker;
